import { Card, Table } from "antd";
import "./index.css";

const ChargesPage = (props) => {
  const columns = [
    {
      title: "Payment Mode",
      dataIndex: "paymentMode",
      key: "paymentMode",
      width: "25%",
      render: (text) => <span style={{ fontWeight: 600 }}>{text}</span>,
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: "28%",
    },
    {
      title: "Amount (₹)",
      dataIndex: "amount",
      key: "amount",
      width: "24%",
    },
    {
      title: "Platform Fee",
      dataIndex: "platformFee",
      key: "platformFee",
      width: "20%",
    },
  ];

  const data = [
    {
      key: "1",
      paymentMode: "Debit Card",
      type: "Visa / Mastercard",
      amount: "<= 2000",
      platformFee: "0.40% per transaction",
    },
    {
      key: "2",
      paymentMode: "Debit Card",
      type: "Visa / Mastercard",
      amount: ">= 2000 ",
      platformFee: "0.90% per transaction",
    },
    {
      key: "3",
      paymentMode: "Debit Card",
      type: "Rupay",
      amount: "Any",
      platformFee: "NIL",
    },
    {
      key: "4",
      paymentMode: "Credit Card",
      type: "Visa/ Mastercard/ RuPay",
      amount: "Any",
      platformFee: "1.20% per transaction",
    },
    {
      key: "6",
      paymentMode: "UPI",
      type: "NIL",
      amount: "Any",
      platformFee: "NIL",
    },
  ];

  return (
    <>
      <div className="topbarstyle">
        <img src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/union_bank_logo_topbar.svg"></img>
      </div>

      <div className="pageStyle">
        <div className="container-card">
          <div className="centered-container">
            <div className="charges-container">
              <Card className="charges-card-width">
                <div className="payment-gateway-text">
                  Payment Gateway Charges
                </div>
                <Table
                  columns={columns}
                  dataSource={data}
                  pagination={false}
                  bordered
                  className="custom-charges-table"
                  style={{ marginTop: "16px", marginBottom: "16px" }}
                />
                <div className="pg-charges-note-text">Please Note :</div>
                <div className="charges-list">
                  <span className="charges-list-text">
                    1. GST will be levied @ 18% on User Charges
                  </span>
                  <span className="charges-list-text">
                    2. Amex cards are not accepted
                  </span>
                </div>
                <div className="terms-and-condition-color">
                  Terms & Conditions apply
                </div>
              </Card>
            </div>
            <br></br>
            <div className="poweredbyEasebuzz">
              <img
                src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/easebuzz_logo.svg"
                alt="Powered by Easebuzz"
              />
            </div>
          </div>
        </div>
        <div className="copyright copyright-space">
          <p>Copyright © 2024 Union Bank of India. All rights reserved</p>
        </div>
      </div>
    </>
  );
};

export default ChargesPage;
